@if (aberta()) {
  <div class="km-busca__fundo" data-testid="busca-fundo" (click)="fechar()"></div>
  <div
    #dialogo
    class="km-busca"
    role="dialog"
    aria-modal="true"
    aria-label="Busca global"
    data-testid="busca-dialogo"
    (keydown)="aoTeclar($event)"
  >
    <div class="km-busca__cabecalho">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input
        #campo
        type="text"
        class="km-busca__campo"
        role="combobox"
        autocomplete="off"
        placeholder="Buscar clientes, tenants ou páginas…"
        aria-label="Buscar"
        aria-autocomplete="list"
        aria-controls="busca-lista"
        aria-describedby="busca-ajuda"
        [attr.aria-expanded]="opcoes().length > 0"
        [attr.aria-activedescendant]="ativa()?.id ?? null"
        [value]="termo()"
        data-testid="busca-input"
        (input)="aoDigitar($any($event.target).value)"
      />
      <button type="button" class="km-busca__fechar" aria-label="Fechar busca" data-testid="busca-fechar" (click)="fechar()">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>
    <p id="busca-ajuda" class="visually-hidden">
      Digite ao menos {{ minimo }} caracteres para buscar clientes e tenants. Use as setas para cima e para baixo para
      escolher, Enter para abrir e Esc para fechar.
    </p>
    <div class="visually-hidden" role="status" aria-live="polite" data-testid="busca-status">
      @if (carregando()) {
        Buscando…
      } @else if (semResultados()) {
        Sem resultados
      } @else {
        {{ opcoes().length }} resultados
      }
    </div>

    <div id="busca-lista" class="km-busca__lista" role="listbox" aria-label="Resultados" data-testid="busca-lista">
      @for (s of secoes(); track s.id) {
        <div role="group" class="km-busca__grupo" [attr.aria-labelledby]="'busca-grupo-' + s.id" [attr.data-testid]="'busca-grupo-' + s.id">
          <div class="km-busca__grupo-titulo" [id]="'busca-grupo-' + s.id">{{ s.rotulo }}</div>
          @for (o of s.opcoes; track o.id) {
            <div
              role="option"
              class="km-busca__opcao"
              [id]="o.id"
              [class.km-busca__opcao--ativa]="o.id === ativa()?.id"
              [attr.aria-selected]="o.id === ativa()?.id"
              [attr.data-testid]="'busca-opcao-' + s.id"
              (click)="ir(o)"
            >
              <i class="bi" [class]="'bi ' + o.icone" aria-hidden="true"></i>
              <span class="km-busca__rotulo">{{ o.rotulo }}</span>
              @if (o.detalhe) {
                <span class="km-busca__detalhe km-num">{{ o.detalhe }}</span>
              }
            </div>
          }
          @if (s.erro) {
            <div class="km-busca__aviso" role="presentation" [attr.data-testid]="'busca-erro-' + s.id">
              Não foi possível buscar em {{ s.rotulo.toLowerCase() }}.
            </div>
          }
        </div>
      }
      @if (semResultados()) {
        <div class="km-busca__aviso" role="presentation" data-testid="busca-vazio">Sem resultados</div>
      }
      @if (carregando()) {
        <div class="km-busca__aviso" role="presentation" data-testid="busca-carregando">Buscando…</div>
      }
    </div>
  </div>
}
